import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    url: null
  },
  setup(__props: any) {

const props = __props as { url?: string }

const style = computed(() => {
    if (props.url) {
        return {
            backgroundImage: 'url(' + props.url + ')'
        }
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "image-back-div",
    style: _normalizeStyle(_unref(style))
  }, [
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 4))
}
}

})